module.exports = __webpack_public_path__ + "img/cta-1.6377a646.jpeg";